var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-table management-main-list-data-table" },
    [
      _c("management-add-button", {
        attrs: {
          label: _vm.$t("AddTicket"),
          disabled: !_vm.userHasManagementPermission(
            "third_party_apis_youtrack_issues_store"
          ),
          "list-missing-permissions": []
        },
        on: {
          buttonClick: function($event) {
            return _vm.$router.push({ name: "tickets-create" })
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "management-section-wrapper" },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "management-section-title" }, [
                _vm._v("\n        " + _vm._s(_vm.$tc("Ticket", 2)) + "\n      ")
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "data-table-search",
                attrs: {
                  label: _vm.$t("Search"),
                  placeholder: _vm.$t("Search"),
                  value: _vm.searchFromParent,
                  "append-icon": "search",
                  "single-line": ""
                },
                on: { input: _vm.updateSearchInParent }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            class: { "no-show-permission": !_vm.userHasPermissionTo("show") },
            attrs: {
              headers: _vm.headers,
              items: _vm.filterTickets,
              page: _vm.pagination.page,
              "sort-by": _vm.pagination.sortBy,
              "sort-desc": _vm.pagination.descending,
              "items-per-page": _vm.paginationTicketsList.rowsPerPage,
              search: _vm.searchFromParent,
              loading: _vm.loading,
              "loading-text": "",
              "items-per-page-text": _vm.rowsPerPageText,
              "items-per-page-items": _vm.rowsPerPageItems,
              "header-props": { sortIcon: _vm.sortIcon },
              "footer-props": {
                prevIcon: _vm.prevIcon,
                nextIcon: _vm.nextIcon,
                "items-per-page-options": _vm.rowsPerPageItems
              },
              "hide-default-header": ""
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "update:itemsPerPage": function($event) {
                return _vm.$set(
                  _vm.paginationTicketsList,
                  "rowsPerPage",
                  $event
                )
              },
              "update:items-per-page": function($event) {
                return _vm.$set(
                  _vm.paginationTicketsList,
                  "rowsPerPage",
                  $event
                )
              },
              pagination: function($event) {
                return _vm.setRowsOnLocalStorage(
                  _vm.dataTableTicketsListId,
                  _vm.paginationTicketsList.rowsPerPage
                )
              }
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function() {
                  return [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c(
                            "table-header-cell",
                            {
                              staticStyle: { "padding-left": "39px" },
                              attrs: {
                                header: _vm.headers[0],
                                pagination: _vm.pagination,
                                filterActive: !!_vm.filters.idReadable,
                                "sort-icon":
                                  _vm.pagination.descending &&
                                  _vm.headers[0].value === _vm.pagination.sortBy
                                    ? "arrow_drop_up"
                                    : "arrow_drop_down"
                              },
                              on: { sort: _vm.changeSort }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field",
                                attrs: {
                                  label: _vm.$tc("ID", 1),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filters.idReadable,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filters, "idReadable", $$v)
                                  },
                                  expression: "filters.idReadable"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "table-header-cell",
                            {
                              attrs: {
                                header: _vm.headers[1],
                                pagination: _vm.pagination,
                                filterActive: !!_vm.filters.summary,
                                "sort-icon":
                                  _vm.pagination.descending &&
                                  _vm.headers[1].value === _vm.pagination.sortBy
                                    ? "arrow_drop_up"
                                    : "arrow_drop_down"
                              },
                              on: { sort: _vm.changeSort }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field",
                                attrs: {
                                  label: _vm.$t("Title"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filters.summary,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filters, "summary", $$v)
                                  },
                                  expression: "filters.summary"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "table-header-cell",
                            {
                              attrs: {
                                header: _vm.headers[2],
                                pagination: _vm.pagination,
                                filterActive: !!_vm.filters.state,
                                "sort-icon":
                                  _vm.pagination.descending &&
                                  _vm.headers[2].value === _vm.pagination.sortBy
                                    ? "arrow_drop_up"
                                    : "arrow_drop_down"
                              },
                              on: { sort: _vm.changeSort }
                            },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field",
                                attrs: {
                                  label: _vm.$t("State"),
                                  items: _vm.stateOptions,
                                  pagination: _vm.pagination,
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filters.state,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filters, "state", $$v)
                                  },
                                  expression: "filters.state"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "table-header-cell",
                            {
                              attrs: {
                                header: _vm.headers[3],
                                pagination: _vm.pagination,
                                filterActive: !!_vm.filters.createdBy,
                                "sort-icon":
                                  _vm.pagination.descending &&
                                  _vm.headers[3].value === _vm.pagination.sortBy
                                    ? "arrow_drop_up"
                                    : "arrow_drop_down"
                              },
                              on: { sort: _vm.changeSort }
                            },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field",
                                attrs: {
                                  label: _vm.$t("CreatedBy"),
                                  items: _vm.userOptions,
                                  pagination: _vm.pagination,
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filters.createdBy,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filters, "createdBy", $$v)
                                  },
                                  expression: "filters.createdBy"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("table-header-cell", {
                            attrs: {
                              header: _vm.headers[4],
                              pagination: _vm.pagination,
                              filterActive: !!_vm.filters.created
                            },
                            on: { sort: _vm.changeSort }
                          }),
                          _vm._v(" "),
                          _c("table-header-cell", {
                            attrs: {
                              header: _vm.headers[5],
                              pagination: _vm.pagination,
                              sortIsDisabled: true
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "item",
                fn: function(props) {
                  return [
                    _c(
                      "tr",
                      {
                        class: {
                          "cursor-pointer": _vm.userHasPermissionTo("show")
                        },
                        on: {
                          click: function($event) {
                            return _vm.viewItem(props.item.id)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(props.item.idReadable))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.summary))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.state))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(props.item.fibercloud_user_name))
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.created))]),
                        _vm._v(" "),
                        _vm.userCanEditOrRemoveItems
                          ? _c(
                              "td",
                              [
                                _c("app-datatable-action-buttons", {
                                  attrs: {
                                    "user-can-edit": _vm.userHasPermissionTo(
                                      "update"
                                    ),
                                    "user-can-delete": _vm.userHasPermissionTo(
                                      "destroy"
                                    )
                                  },
                                  on: {
                                    edit: function($event) {
                                      return _vm.editTicket(props.item.id)
                                    },
                                    delete: function($event) {
                                      return _vm.askConfirmationToDeleteItem(
                                        props.item
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                }
              },
              {
                key: "pageText",
                fn: function(props) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.pageStart) +
                        " - " +
                        _vm._s(props.pageStop) +
                        " " +
                        _vm._s(_vm.$t("tables.Of")) +
                        "\n        " +
                        _vm._s(props.itemsLength) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "no-results",
                fn: function() {
                  return [
                    _c("data-table-no-results", {
                      attrs: { search: _vm.searchFromParent }
                    })
                  ]
                },
                proxy: true
              },
              {
                key: "no-data",
                fn: function() {
                  return [_vm.loading ? _c("div") : _vm._e()]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("DeleteTicket"),
          content:
            _vm.$t("DeleteConfirmation") +
            " " +
            _vm.itemToDelete.idReadable +
            "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes"),
          loading: _vm.loadingDelete
        },
        on: { mainAction: _vm.cancelDelete, secondaryAction: _vm.deleteTicket }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d1c95b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d1c95b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/TechnicalSupport/TicketsList.vue
// module id = null
// module chunks = 